module.exports = __webpack_public_path__ + "img/lock.3ca42c4b.svg";